<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
      <DynamicSidePanel />
      <DynamicMobilePanel />
      <DynamicPopups />
      <DynamicActionBar />
      <DynamicActionMenu />
      <template v-if="authStore.getIsLoggedIn">
        <DynamicTour />
      </template>
    </NuxtLayout>
  </div>
</template>

<script setup lang="ts">
import { captureException } from '@sentry/vue'

const authStore = useAuthStore()
const brandingStore = useBrandingStore()

useHead(() => ({
  link: [
    {
      key: 'favicon',
      rel: 'icon',
      type: 'image/x-icon',
      href: brandingStore.getFaviconUrl || '/favicon.ico',
    },
  ],
}))

onNuxtReady(async () => {
  if (!authStore.getIsLoggedIn) return
  try {
    await useGetUser()
    await useGetBranding()
  } catch (err) {
    captureException(err)
  }
})

onMounted(() => {
  // Work around for https://github.com/nuxt/nuxt/issues/13350
  // @TODO Remove when fixed
  if (typeof window !== 'undefined') {
    window.addEventListener('error', (ev) => {
      const messages = [
        `Uncaught NotFoundError: Failed to execute 'insertBefore' on 'Node': The node before which the new node is to be inserted is not a child of this node.`, // Chromium
        `NotFoundError: Node.insertBefore: Child to insert before is not a child of this node`, // Firefox
        `NotFoundError: The object can not be found here.`, // Safari
      ]
      if (messages.some((message) => ev.message.includes(message))) {
        ev.preventDefault()
        window.location.reload()
      }
    })
  }
})
</script>
